import React, { useEffect, useState } from "react";
import axios from "axios";
import defaultUserImg from "../../../assets/images/defaultuserimgdark.png";
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  Label,
  Button,
  Form,
  Input,
  FormFeedback,
  InputGroup,
  InputGroupText,
  Alert,
  Modal, ModalHeader,
} from "reactstrap";
import { useFormik } from "formik";
import { Target } from "lucide-react";
import { json } from "stream/consumers";
import {Link} from 'react-router-dom'

const baseUrl = process.env.REACT_APP_BASE_URL;

const validateEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
const validatePhone = (phone: string) => /^\+?[0-9]{10,15}$/.test(phone);

const validate = (values: any) => {
  const errors: any = {};
  if (!values.firstname) errors.firstname = "First name is required";
  if (!values.lastname) errors.lastname = "Last name is required";
  if (!values.email) errors.email = "Email is required";
  else if (!validateEmail(values.email)) errors.email = "Invalid email format";
  if (!values.phone) errors.phone = "Phone number is required";
  else if (!validatePhone(values.phone)) errors.phone = "Enter a valid phone number";
  return errors;
};

interface FormValues {
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
  image: string | File;
  currentPassword:string;
  newPassword:string;
  confirmPassword:string;
  
}

const AdmProfile = () => {
  document.title = "Admin Profile | BizServe";
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [alertMsgg, setAlertMsgg] = useState<any>({open:false, type:"success", content:'Messages here.', time:'2500'});
  const handleAlertMsggClose = ( event?: React.SyntheticEvent | Event, reason?: string) => {  
      if (reason === "clickaway") { return; }
      setAlertMsgg({ ...alertMsgg, open: false })
  };

  const [showloader, setshowloader] = useState(true);
  const is_two_fact_status = JSON.parse(localStorage.getItem('enable_two_fact') || 'false')
  console.log("is_two_fact_enable----",is_two_fact_status)
  const [istwofactenable, settwofactenable] = useState(false);
  const [qrImage, setqrImage] = useState<string | null>(null);
  const [otp, setotp] = useState("");
  const [step, setStep] = useState(0);
  const [recoverykey, setrecoverykey] = useState<string[]>([]);
  const [modal_center, setmodal_center] = useState(false);
  const [disableotp, setdisableotp] = useState("");
  const [secretkey, setsecretkey] = useState("");
  


  const toggletwofactauth = async() => {
    try{
      setshowloader(true);
      const newstatus = !istwofactenable;
      settwofactenable(newstatus);
      const user_email = JSON.parse(localStorage.getItem('userdata') || '{}').email
      const formdata = new FormData();
      formdata.append("email", user_email)
      const response = await axios.post(`/accounts/two_factor_auth`,formdata,
        {headers :{'Content-Type': 'multipart/form-data'}});
        console.log("twofactorstatus______",response)
        if(response.status === 'UPDATED'){
          const qr = response.qr_code
          setqrImage(qr)
          setStep(1)
          const sec = response.secret
          setsecretkey(sec)
          setshowloader(false);
        }
    }catch (error:any) {
        if (error.response) {
            if ([401, 422].includes(error.response.status)) {
                console.log('Error in stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
                setTimeout(() => {setAlertMsgg(prev => ({ ...prev, open: false }));
                }, 3000);
            }
            else if (error.response.status === 403) {
                console.log('Error stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                setTimeout(()=>{window.location.href="/logout"}, 2000)
            } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                setTimeout(() => {setAlertMsgg(prev => ({ ...prev, open: false }));
                }, 2000);
            }
        } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            setTimeout(() => {setAlertMsgg(prev => ({ ...prev, open: false }));
                }, 2000);
        }
        setshowloader(false)
    }
  }

  const handleotpchnage = (e) => {
    setotp(e.target.value)
  }
  const verify_two_fact = async() => {
    try{
      if(!otp){
            setAlertMsgg({open:true, content : "Please enter the OTP.", type : "error"})
          setTimeout(() => {
            setAlertMsgg((prev) => ({...prev, open:false}));
          },3000)
          return;
        }
      setshowloader(true)
      const user_email = JSON.parse(localStorage.getItem('userdata') || '{}').email
      console.log("user_email__2222_",user_email)
      const formData = new FormData();
      formData.append("email", user_email)
      formData.append("otp",otp)
      const response = await axios.post(`accounts/two_factor_verify`,formData,
        {headers :{'Content-Type': 'multipart/form-data'}});
        if(response.status === "VERIFY"){
          const recover = response.recovery_codes
          setrecoverykey(recover);
          localStorage.setItem("enable_two_fact",JSON.stringify(response.enable_two_fact))
          setStep(2);
          setshowloader(false)
          setAlertMsgg({open:true, content : "Two-Factor Authentication Updated Successfully", type : "success"})
          setTimeout(() => {
            setAlertMsgg((prev) => ({...prev, open:false}));
          },3000)
        }
    }catch (error:any) {
        if (error.response) {
            if ([401, 422].includes(error.response.status)) {
                console.log('Error in stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
                setTimeout(() => {setAlertMsgg(prev => ({ ...prev, open: false }));
                }, 3000);
            }
            else if (error.response.status === 403) {
                console.log('Error stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                setTimeout(()=>{window.location.href="/logout"}, 2000)
            } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                setTimeout(() => {setAlertMsgg(prev => ({ ...prev, open: false }));
                }, 2000);
            }
        } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            setTimeout(() => {setAlertMsgg(prev => ({ ...prev, open: false }));
                }, 2000);
        }
        setshowloader(false)
    }
  }

  const disableotpchnage = (e) => {
    setdisableotp(e.target.value)
  }
  
  const verify_disable_otp = async() =>{
    try{
      if(!disableotp){
            setAlertMsgg({open:true, content : "Please enter the OTP.", type : "error"})
          setTimeout(() => {
            setAlertMsgg((prev) => ({...prev, open:false}));
          },3000)
          return;
        }
      setshowloader(true);
      const user_email = JSON.parse(localStorage.getItem('userdata') || '{}').email
      const formdata = new FormData ;
      formdata.append("email",user_email);
      formdata.append("otp",disableotp);
      const response = await axios.post(`/accounts/disable_two_factor`,formdata,
        {'headers': {'Content-Type' : 'multipart/form-data'}});
        if(response.status === "Deactive"){
          localStorage.removeItem("enable_two_fact");
          setshowloader(false);
          setAlertMsgg({open:true, content : "Two-Factor Authentication Updated Successfully", type : "success"})
          setTimeout(() =>{
            setAlertMsgg((prev) => ({...prev, open:false}));
          },3000)
          window.location.reload()
        }
    }catch (error:any) {
        if (error.response) {
            if ([401, 422].includes(error.response.status)) {
                console.log('Error in stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
                setTimeout(() => {setAlertMsgg(prev => ({ ...prev, open: false }));
                }, 3000);
            }
            else if (error.response.status === 403) {
                console.log('Error stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                setTimeout(()=>{window.location.href="/logout"}, 2000)
            } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                setTimeout(() => {setAlertMsgg(prev => ({ ...prev, open: false }));
                }, 2000);
            }
        } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            setTimeout(() => {setAlertMsgg(prev => ({ ...prev, open: false }));
                }, 2000);
        }
        setshowloader(false)
    }
  }

  const [previewImage, setPreviewImage] = useState<string | null>(null);

  const formik = useFormik<FormValues>({
    initialValues: {
      firstname: "",
      lastname: "",
      email: "",
      phone: "",
      image: "",
      currentPassword:"",
      newPassword:"",
      confirmPassword:"",

    },
    validate,
    onSubmit: async (values) => {
      const { firstname, lastname, email, phone, image } = values;

      if (!firstname || !lastname || !email || !phone) {
        setAlertMsgg({ open: true, content: "Please fill all fields", type: "error" });
        return;
      }

      const data = new FormData();
      data.append("first_name", firstname);
      data.append("last_name", lastname);
      data.append("email", email);
      data.append("phone", phone);

      if (image instanceof File) {
        // console.log("Appending file:", image);
        data.append("profile_pic", image);
      }

      try {
        setshowloader(true)
        const res = await axios.post(`/accounts/admin_profileupdate`, data,{
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        if (res.status === 'DONE') {
          console.log('res ka response',res)
          setAlertMsgg({ open: true, content: "Profile updated Successfully!", type: "success" });
          setshowloader(false)
          setTimeout(() => {
            setAlertMsgg((prev) => ({ ...prev, open: false }));
          }, 4000);
          localStorage.setItem("userdata", JSON.stringify(res.user));
          window.dispatchEvent(new Event("refreshProfile"));
        } else if (res.status === "ierror") {
          setAlertMsgg({ open: true, content: "User already exists!", type: "error" });
          setshowloader(false)
        }
      } catch (error:any) {
        if (error.response) {
            if ([401, 422].includes(error.response.status)) {
              console.log('Error in stripe payment')
              setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
            }
            else if (error.response.status === 403) {
              console.log('Error stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                setTimeout(()=>{window.location.href="/logout"}, 2000)
            } else {
              console.log('An error occurred')
              setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
            }
        } else {
          console.log('An error occurred')
          setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
        }
        setshowloader(false)
    }
    },
  });

  const handlePasswordUpdate = async () => {
    console.log('clicked')
    formik.setErrors({});
    const errors: any = {};
    
    const { currentPassword, newPassword, confirmPassword } = formik.values;
    // Reset previous errors
    // Required fields
    if (!currentPassword) errors.currentPassword = "Current password is required";
    if (!newPassword) errors.newPassword = "New password is required";
    if (!confirmPassword) errors.confirmPassword = "Confirm password is required";
    // Current vs New
    if (currentPassword && newPassword && currentPassword === newPassword) {
      errors.newPassword = "New password cannot be same as current password";
    }
    // New vs Confirm
    if (newPassword && confirmPassword && newPassword !== confirmPassword) {
      errors.confirmPassword = "New and confirm passwords do not match";
    }
  
    // Strong password check
    const passwordPattern =
      /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{6,}$/;
    if (newPassword && !passwordPattern.test(newPassword)) {
      errors.newPassword =
        "Password must contain at least 6 characters, one uppercase letter, one number, and one special symbol";
    }

    // If any errors, set them in Formik and stop
    if (Object.keys(errors).length > 0) {
      formik.setErrors(errors);
      return;
    }
    const data = new FormData();
    data.append("current_password", currentPassword);
    data.append("new_password", newPassword);
    data.append("confirm_Password", confirmPassword);
    data.append("access_token", localStorage.getItem("access_token") || "");
    console.log('currentPassword',currentPassword)
    try {
      setshowloader(true);
      const response = await axios.post("/accounts/change_password", data, {
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true,
      });
      console.log('response ka data ',response)
      if (response.status === "success") {
        setAlertMsgg({ ...alertMsgg, open: true, content:"Password updated Sucessfully!", type:"success" });
        setshowloader(false);
        setTimeout(() => {
          setAlertMsgg(prev => ({ ...prev, open: false }));
        }, 4000);
        formik.resetForm();
      }
    } catch (error: any) {
      if (error.response) {
        console.log('error.response',error.response)
        if ([401, 422].includes(error.response.status)) {
          setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
        } else if (error.response.status === 403) {
          setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
          setTimeout(() => (window.location.href = "/logout"), 2000);
        } else {
          setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
        }
      } else {
        setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
      }
      setshowloader(false);

    }
  };

 

  const handleProfilePicChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      formik.setFieldValue("image", file);

      const reader = new FileReader();
      reader.onloadend = (event) => {
        if (typeof event.target?.result === "string") {
          // console.log('image ka data _________',event.target.result)
          setPreviewImage(event.target.result);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const fetchCustomer = async () => {
    try {
      setshowloader(true)
      const response = await axios.get(`/accounts/get_admin`,{});
      if (response.status === "SENT") {
        setshowloader(false)
        const userData = response.userprofile;
        console.log('userData',userData)
        formik.setValues({
          firstname: userData.user.first_name || "",
          lastname: userData.user.last_name || "",
          email: userData.user.email || "",
          phone: userData.user.phone || "",
          image: userData.user.profile_pic || "",
          currentPassword:"",
          newPassword:"",
          confirmPassword:"",
        });
      }
    } catch (error:any) {
      if (error.response) {
          if ([401, 422].includes(error.response.status)) {
            console.log('Error in stripe payment')
            setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
          }
          else if (error.response.status === 403) {
            console.log('Error stripe payment')
              setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
              setTimeout(()=>{window.location.href="/logout"}, 2000)
          } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
          }
      } else {
        console.log('An error occurred')
        setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
      }
      setshowloader(false)
  }
  };

  useEffect(() => {
    fetchCustomer();
  }, []);
  
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
        {alertMsgg.open && (
            <Alert
            color={alertMsgg.type === "success" ? "success" : "danger"}
            toggle={handleAlertMsggClose}
            style={{ fontWeight: "bold" }}
            >
            {alertMsgg.content}
            </Alert>
            )}
            <div className="loaderContainer" hidden={!showloader}>
            <div className="spinner">
              <div></div>  
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
            </div>
          </div>

          <Card className="rounded-4">
            <CardBody>
              <Row>
                <Col md={12}>
                  <Card className="profileCover rounded-4">
                    <CardBody></CardBody>
                  </Card>
                </Col>
                <Col xl={12}>
                  <Card className="bg-transparent">
                    <CardBody>
                      <Form onSubmit={formik.handleSubmit}>
                        <Row className="border-bottom mb-4">
                          <Col md={12} className="profileImgSet">
                            <div
                              className="mb-4 text-center position-relative"
                              style={{ display: "inline-block" }}
                            >
                              <img
                                src={
                                  previewImage
                                    ? previewImage
                                    : typeof formik.values.image === "string"
                                    ? `${formik.values.image}`
                                    : defaultUserImg
                                }
                                alt="Profile"
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  objectFit: "cover",
                                  borderRadius: "50%",
                                  border: "2px solid #dee2e6",
                                }}
                                onError={(e) => {
                                  console.error('Error loading profile image:', e);
                                  e.currentTarget.onerror = null;
                                  e.currentTarget.src = defaultUserImg;
                                }}
                              />
                              <label htmlFor="upload-profile-pic" className="imgFloatPencil">
                                <i className="bx bxs-pencil"></i>
                              </label>
                              <input
                                type="file"
                                id="upload-profile-pic"
                                accept="image/*"
                                onChange={handleProfilePicChange}
                                style={{ display: "none" }}
                              />
                            </div>
                            <p className="mb-0 font-size-18 fw-medium">
                              {formik.values.firstname} {formik.values.lastname}
                            </p>
                            <p className="mb-0 font-size-15">{formik.values.email}</p>
                          </Col>
                          <Col md={3}>
                            <p className="mb-0 font-size-16 text-dark fw-medium">Personal Info</p>
                            <p>You can change your personal information setting here.</p>
                          </Col>
                          <Col md={9}>
                            <Card className="rounded-4 border">
                              <CardBody className="p-4">
                                <Row>
                                  <Col md={6}>
                                    <div className="mb-3">
                                      <Label htmlFor="firstname">First Name<span className="text-danger px-1">*</span></Label>
                                      <Input
                                        type="text"
                                        name="firstname"
                                        id="firstname"
                                        placeholder="Enter your first name"
                                        value={formik.values.firstname}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        invalid={formik.touched.firstname && !!formik.errors.firstname}
                                      />
                                      <FormFeedback>{formik.errors.firstname}</FormFeedback>
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="mb-3">
                                      <Label htmlFor="lastname">Last Name<span className="text-danger px-1">*</span></Label>
                                      <Input
                                        type="text"
                                        name="lastname"
                                        id="lastname"
                                        placeholder="Enter your last name"
                                        value={formik.values.lastname}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        invalid={formik.touched.lastname && !!formik.errors.lastname}
                                      />
                                      <FormFeedback>{formik.errors.lastname}</FormFeedback>
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="mb-3">
                                      <Label htmlFor="email">Email<span className="text-danger px-1">*</span></Label>
                                      <Input
                                        type="email"
                                        name="email"
                                        id="email"
                                        placeholder="Enter your email"
                                        value={formik.values.email}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        invalid={formik.touched.email && !!formik.errors.email}
                                      />
                                      <FormFeedback>{formik.errors.email}</FormFeedback>
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="mb-3">
                                      <Label htmlFor="phone">Phone<span className="text-danger px-1">*</span></Label>
                                      <Input
                                        type="text"
                                        name="phone"
                                        id="phone"
                                        placeholder="Enter your phone number"
                                        value={formik.values.phone}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        invalid={formik.touched.phone && !!formik.errors.phone}
                                      />
                                      <FormFeedback>{formik.errors.phone}</FormFeedback>
                                    </div>
                                  </Col>
                                  <Col md={12} className="d-flex justify-content-end">
                                    <Button type="submit" color="primary" className="w-md">
                                      UPDATE
                                    </Button>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>

                        <Row className="border-bottom mb-4">
                        <Col md={4}>
                          <p className="mb-0 font-size-16 text-dark fw-medium">Change Password</p>
                          <p></p>
                        </Col>
                        <Col md={12}>
                          <Card className="rounded-4 border">
                            <CardBody className="p-4">
                              {/* <form onSubmit={formik.handleSubmit}> */}
                                <Row>
                                  {/* Current Password */}
                                  <Col md={4}>
                                    <div className="mb-3">
                                      <Label htmlFor="currentPassword">
                                        Current Password <span className="text-danger px-1">*</span>
                                      </Label>
                                      <InputGroup>
                                        <Input
                                          type={showCurrent ? "text" : "password"}
                                          name="currentPassword"
                                          id="currentPassword"
                                          placeholder="Enter current password"
                                          value={formik.values.currentPassword}
                                          onChange={formik.handleChange}
                                          onBlur={formik.handleBlur}
                                          invalid={
                                            formik.touched.currentPassword &&
                                            !!formik.errors.currentPassword
                                          }
                                        />
                                        <InputGroupText
                                          role="button"
                                          onClick={() => setShowCurrent(!showCurrent)}
                                          style={{ cursor: "pointer" }}
                                        >
                                          <i className={`mdi ${showCurrent ? "mdi-eye-off" : "mdi-eye"}`}></i>
                                        </InputGroupText>
                                        <FormFeedback>{formik.errors.currentPassword}</FormFeedback>
                                      </InputGroup>
                                    </div>
                                  </Col>
                                   {/* New Password */}
                                  <Col md={4}>
                                    <div className="mb-3">
                                      <Label htmlFor="newPassword">
                                        New Password <span className="text-danger px-1">*</span>
                                      </Label>
                                      <InputGroup>
                                        <Input
                                          type={showNew ? "text" : "password"}
                                          name="newPassword"
                                          id="newPassword"
                                          placeholder="Enter new password"
                                          value={formik.values.newPassword}
                                          onChange={formik.handleChange}
                                          onBlur={formik.handleBlur}
                                          invalid={
                                            formik.touched.newPassword &&
                                            !!formik.errors.newPassword
                                          }
                                        />
                                        <InputGroupText
                                          role="button"
                                          onClick={() => setShowNew(!showNew)}
                                          style={{ cursor: "pointer" }}
                                        >
                                          <i className={`mdi ${showNew ? "mdi-eye-off" : "mdi-eye"}`}></i>
                                        </InputGroupText>
                                      <FormFeedback>{formik.errors.newPassword}</FormFeedback>
                                      </InputGroup>
                                      <small className="text-muted d-block mt-1">
                                        <strong>Password Requirements:</strong>
                                        <ul className="mb-0 ps-3" style={{ fontSize: "0.85rem" }}>
                                          <li>At least 6 characters</li>
                                          <li>One uppercase letter (A-Z)</li>
                                          <li>One number (0-9)</li>
                                          <li>One special character (!@#$%^&*...)</li>
                                        </ul>
                                      </small>
                                    </div>
                                  </Col>
                                  {/* Confirm Password */}
                                  <Col md={4}>
                                    <div className="mb-3">
                                      <Label htmlFor="confirmPassword">
                                        Confirm Password <span className="text-danger px-1">*</span>
                                      </Label>
                                      <InputGroup>
                                        <Input
                                          type={showConfirm ? "text" : "password"}
                                          name="confirmPassword"
                                          id="confirmPassword"
                                          placeholder="Confirm new password"
                                          value={formik.values.confirmPassword}
                                          onChange={formik.handleChange}
                                          onBlur={formik.handleBlur}
                                          invalid={
                                            formik.touched.confirmPassword &&
                                            !!formik.errors.confirmPassword
                                          }
                                        />
                                        <InputGroupText
                                          role="button"
                                          onClick={() => setShowConfirm(!showConfirm)}
                                          style={{ cursor: "pointer" }}
                                        >
                                          <i className={`mdi ${showConfirm ? "mdi-eye-off" : "mdi-eye"}`}></i>
                                        </InputGroupText>
                                      <FormFeedback>{formik.errors.confirmPassword}</FormFeedback>
                                      </InputGroup>
                                    </div>
                                  </Col>
                                  <Col md={12} className="d-flex justify-content-end">
                                    <Button onClick={handlePasswordUpdate} color="primary" className="w-md">
                                      Update Password
                                    </Button>
                                  </Col>
                                </Row>
                              {/* </form> */}
                            </CardBody>
                          </Card>
                        </Col>
                        </Row>

                        <Row className="border-bottom">
                          <Col>
                            <p className="mb-3 font-size-16 text-dark fw-medium">Two-factor authentication</p>
                            {!is_two_fact_status && step !== 1 && step !== 4  &&(
                              <div className="mb-3">
                                <p className="mb-1">Two-factor authentication is disabled
                                </p>
                                <p>For enhanced security, please enable two-factor authentication (2FA) using an authenticator app such as Microsoft Authenticator or Google Authenticator.</p>
                                <button className="btn btn-primary btn-sm" type="button" onClick={toggletwofactauth} > Enable two factor
                                </button>
                              </div>
                            )}

                           {is_two_fact_status && step !== 2 && step !==3 &&(
                            <div className="mb-3">
                              <p className="mb-1">Two-factor authentication is enabled.
                              </p>
                              <button className="btn btn-primary btn-sm" type="button" onClick={() => setStep(3)} >Disable Two-Factor Authentication
                              </button>
                            </div>
                            )}

                            { step === 3 &&(
                              <Col md={6}>
                                <Label htmlFor="lastname">Enter the code from your authenticator app to disable Two-Factor Authentication, or use your recovery code if you no longer have access to the app.<span className="text-danger px-1">*</span></Label>
                                <Input
                                  type="text"
                                  id="disableotp"
                                  name="disableotp"
                                  value={disableotp}
                                  onChange={disableotpchnage}
                                  placeholder="Enter 6-digit code"
                                  maxLength={6}
                                  onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault(); // stops form submit
                                  }
                                }}
                                />
                                <button className="btn btn-primary btn-sm mt-2 mb-2" type="button"  onClick={verify_disable_otp}>Continue</button>
                              </Col>
                            )}

                            {secretkey  &&(
                              <div className="mb-3">
                                <p>Enable Two-Factor Authentication by scanning the QR code with an authenticator app such as Google Authenticator or Microsoft Authenticator to generate secure one-time passcodes.</p>
                                {/* <p >If you can’t scan the QR code, enter the secret key manually in your authenticator app to generate secure one-time passcodes.</p> */}
                                <p>Your Secret Key is : <strong>{secretkey}</strong></p>
                              </div>
                            )}
                              
                            {step === 1 &&(
                              <div className="mb-3">
                                <img  src={`data:image/png;base64,${qrImage}`}
                                alt="QR Code" className="border" style={{ width: "200px", height: "200px" }} 
                                />
                                <p >If you can’t scan the QR code, enter the secret key manually in your authenticator app to generate secure one-time passcodes.</p>
                              </div>
                            )}

                          {step === 1 &&(
                            <div className="mb-3">
                              <Label htmlFor="lastname">Enter the code from your authenticator app<span className="text-danger px-1">*</span></Label>
                              <Input
                                type="text"
                                id="otp"
                                name="otp"
                                value={otp}
                                onChange={handleotpchnage}
                                placeholder="Enter 6-digit code"
                                maxLength={6}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault(); // stops form submit
                                  }
                                }}
                              />
                              <div className="d-flex gap-1 align-items-center mt-2">
                                <button className="btn btn-primary btn-sm" type="button"  onClick={verify_two_fact}>Continue</button>
                                {/* <button className="btn btn-secondary btn-sm" type="button" onClick={() => setStep(4)}>Other Method</button> */}
                              </div>
                              
                            </div>
                          )}

                          {/* { step === 4 &&(
                            <div className="mb-3">
                              <p >If you can’t scan the QR code, enter the secret key manually in your authenticator app to generate the code.</p>
                              <Label htmlFor="lastname">Enter the code from your authenticator app <span className="text-danger px-1">*</span></Label>
                              <Input
                              type="text"
                              id="otp"
                              name="otp"
                              value={otp}
                              onChange={handleotpchnage}
                              placeholder="Enter otp"
                              maxLength={6}
                              />
                              <button className="btn btn-primary btn-sm mt-2" type="button" onClick={verify_two_fact}>Continue</button>
                            </div>
                          )} */}
                          </Col>

                          {step === 2 &&(
                            <div className="mb-3">
                              <h3>Save Your Recovery Codes</h3>
                              <ul className="ps-0">
                                {recoverykey.map((key, index) => (
                                <li key={index}>{key}</li>
                              ))}
                              </ul>
                              <div className="d-flex align-items-center gap-1">
                                <button type="button" className="btn btn-primary btn-sm" onClick={() => {
                                  const content = recoverykey.join("\n");
                                  const blob = new Blob([content], {type :"text/plain"});
                                  const link = document.createElement("a");
                                  link.href = URL.createObjectURL(blob)
                                  link.download = "recovery-key.txt";
                                  link.click()
                                  }}>Download Recovery Codes
                                </button>
                                <button className="btn btn-secondary btn-sm" type="button" onClick={() => setmodal_center(true)} >Next
                                </button>
                              </div>
                            </div>
                          )}

                          <Modal
                            isOpen={modal_center}
                            centered
                            className="rounded-4">
                            <ModalHeader className="py-3 px-4" >
                              <div className="modal-title mt-0 font-size-16 text-dark">
                                  Two-Factor Authentication Enabled
                              </div>
                            </ModalHeader>
                            <div className="p-6">
                              <Row>
                                {/* <h2>Two factor Authentication is now enabled in your account</h2> */}
                                <p>Your account is now protected with two-factor authentication.The setup is complete, and your login is more secure.</p>
                                <div className="d-flex justify-content-start">
                                  <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>Done</button>
                                </div>
                              </Row>
                            </div>
                          </Modal>

                        </Row>
                      </Form>
                    </CardBody>
                  </Card>
                </Col>
                

                
              </Row>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AdmProfile;
